import React from "react"
import PropTypes from "prop-types"

import {
  FeatureBanner,
  PageSpacer,
  ImageText,
  PageTransition,
  ProductCarousel,
  GuaranteesGrid,
  TextCarousel,
  StandardBanner,
  IntroText,
  ContactMap,
  ContactForm,
  RecentPosts,
  ProductRange,
} from "./"

const BlockZone = ({ blocks }) => {
  const block = blocks.map(block => {
    switch (block._type) {
      case "pageSpacer":
        return <PageSpacer {...block} />
      case "featureBanner":
        return <FeatureBanner {...block} />
      case "standardBanner":
        return <StandardBanner {...block} />
      case "imageText":
        return <ImageText {...block} />
      case "pageTransition":
        return <PageTransition {...block} />
      case "productCarousel":
        return <ProductCarousel {...block} />
      case "guaranteesGrid":
        return <GuaranteesGrid {...block} />
      case "textCarousel":
        return <TextCarousel {...block} />
      case "introText":
        return <IntroText {...block} />
      case "contactMap":
        return <ContactMap {...block} />
      case "contactForm":
        return <ContactForm {...block} />
      case "recentPosts":
        return <RecentPosts {...block} />
      case "productRange":
        return <ProductRange {...block} />
      default:
        return null
    }
  })
  return <>{block}</>
}

BlockZone.propTypes = {
  blocks: PropTypes.array.isRequired,
}

export default BlockZone
